import React from 'react'
import { withIcon } from '../../withIcon'

function SortAscIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.375 6C3.375 5.65482 3.65482 5.375 4 5.375H11C11.3452 5.375 11.625 5.65482 11.625 6C11.625 6.34518 11.3452 6.625 11 6.625H4C3.65482 6.625 3.375 6.34518 3.375 6ZM17.5581 5.55806C17.8021 5.31398 18.1979 5.31398 18.4419 5.55806L21.4419 8.55806C21.686 8.80214 21.686 9.19786 21.4419 9.44194C21.1979 9.68602 20.8021 9.68602 20.5581 9.44194L18.625 7.50888V18C18.625 18.3452 18.3452 18.625 18 18.625C17.6548 18.625 17.375 18.3452 17.375 18V7.50888L15.4419 9.44194C15.1979 9.68602 14.8021 9.68602 14.5581 9.44194C14.314 9.19786 14.314 8.80214 14.5581 8.55806L17.5581 5.55806ZM3.375 12C3.375 11.6548 3.65482 11.375 4 11.375H11C11.3452 11.375 11.625 11.6548 11.625 12C11.625 12.3452 11.3452 12.625 11 12.625H4C3.65482 12.625 3.375 12.3452 3.375 12ZM3.375 18C3.375 17.6548 3.65482 17.375 4 17.375H13C13.3452 17.375 13.625 17.6548 13.625 18C13.625 18.3452 13.3452 18.625 13 18.625H4C3.65482 18.625 3.375 18.3452 3.375 18Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SortAscIcon)
